import type { RouteRecordRaw } from 'vue-router';
import md from '@/router/middlewares';
import workorder from './workorder';
import component from './component';
import roles from '@/constants/roles';

const site: RouteRecordRaw = {
    path: 'sites/:siteId',
    name: 'site-page',
    redirect: { name: 'site-tree' },
    meta: {
        middlewares: [md.getSiteInfo, md.isSiteIncludedInClient],
    },
    children: [
        component,
        workorder,
        {
            meta: {
                title: 'sitePage.siteDashboard',
                img: 'SiteDashboard.svg',
                allowedRoles: ['all'],
            },
            path: 'dashboard',
            name: 'siteDashboard',
            component: () => import('@/views/sites/dashboard/index.vue'),
        },
        {
            meta: {
                title: 'sitePage.siteTree',
                img: 'SiteTree.svg',
                allowedRoles: ['all'],
            },
            path: 'tree',
            name: 'site-tree',
            component: () => import('@/views/sites/SiteTree.vue'),
        },
        {
            meta: {
                title: 'sitePage.workOrdersTemplate',
                img: 'WorkOrderTemplate.svg',
                allowedRoles: ['all'],
            },
            path: 'work-order-templates',
            name: 'siteWoTemplates',
            component: () => import('@/views/workOrders/template/WorkOrdersTemplate.vue'),
        },
        {
            meta: {
                title: 'sitePage.workOrders',
                img: 'WorkOrder.svg',
                allowedRoles: ['all'],
            },
            path: 'work-orders',
            name: 'siteWorkOrders',
            component: () => import('@/views/sites/workorder/SiteWorkorderList.vue'),
        },
        {
            meta: {
                title: 'sitePage.devices',
                img: 'settings_remote.svg',
                allowedRoles: ['all'],
            },
            path: 'devices',
            name: 'siteDevices',
            component: () => import('@/views/sites/SiteDevices.vue'),
        },
        {
            meta: {
                title: 'sitePage.analysisRequest',
                img: 'SiteAnalysisRequest.svg',
                allowedRoles: ['all'],
            },
            path: 'analysis-request',
            name: 'siteAnalysisRequest',
            component: () => import('@/views/sites/SiteAnalysisRequests.vue'),
        },
        {
            meta: {
                title: 'sitePage.reports',
                img: 'Reports.svg',
                allowedRoles: ['all'],
            },
            path: 'reports',
            name: 'siteReports',
            component: () => import('@/views/sites/SiteReports.vue'),
        },
        {
            meta: {
                title: 'sitePage.graphics',
                img: 'Graphics.svg',
                allowedRoles: ['all'],
            },
            path: 'graphics',
            name: 'siteGraphics',
            component: () => import('@/views/sites/SiteGraphics.vue'),
        },
        {
            meta: {
                title: 'sitePage.cart',
                img: 'Orders.svg',
                badge: 'draftOrdersCount',
                allowedRoles: ['all'],
            },
            path: 'cart',
            name: 'siteCart',
            component: () => import('@/views/sites/cart/siteCart.vue'),
        },
        {
            meta: {
                title: 'sitePage.products',
                img: 'Products.svg',
                allowedRoles: ['all'],
            },
            path: 'products',
            name: 'siteProducts',
            component: () => import('@/views/associatedProducts/AssociatedProducts.vue'),
        },
        {
            meta: {
                title: 'sitePage.procedures',
                img: 'Procedures.svg',
                allowedRoles: ['all'],
            },
            path: 'procedures',
            name: 'siteProcedures',
            component: () => import('@/views/sites/SiteProcedures.vue'),
        },
        {
            meta: {
                title: 'sites.document.title',
                img: 'Document.svg',
                allowedRoles: ['all'],
            },
            path: 'document',
            name: 'siteDocument',
            component: () => import('@/views/sites/document/SiteDocuments.vue'),
        },
        {
            meta: {
                title: 'sitePage.info',
                img: 'SiteInfo.svg',
                allowedRoles: ['all'],
            },
            path: 'info',
            name: 'siteInfo',
            component: () => import('@/views/sites/SiteInformation.vue'),
        },
        {
            meta: {
                title: 'sitePage.contacts',
                img: 'Contacts.svg',
                allowedRoles: ['all'],
            },
            path: 'contacts',
            name: 'siteContacts',
            component: () => import('@/views/sites/SiteContact.vue'),
        },
        {
            meta: {
                title: 'sitePage.alerts',
                img: 'Alerts.svg',
                allowedRoles: ['all'],
            },
            path: 'alerts',
            name: 'siteAlerts',
            component: () => import('@/views/sites/alerts/SiteAlerts.vue'),
        },
        {
            meta: {
                title: 'clientPage.massBalance',
                img: 'MassBalance.svg',
                allowedRoles: [
                    roles.ADMINISTRATOR.value,
                    roles.MANAGER.value,
                    roles.SALES_REPRESENTATIVE.value,
                ],
            },
            path: 'mass-balance',
            name: 'siteMassBalance',
            component: () => import('@/views/sites/MassBalance.vue'),
        },
        {
            meta: {
                title: 'sitePage.logs',
                img: 'Logs.svg',
                allowedRoles: [
                    roles.MANAGER.value,
                    roles.ADMINISTRATOR.value,
                    roles.SALES_REPRESENTATIVE.value,
                ],
            },
            path: 'logs',
            name: 'siteLogs',
            component: () => import('@/views/sites/SiteLogs.vue'),
        },
    ],
};

export default site;
